<div class="title">
  <mat-icon>star</mat-icon>
  Units
</div>
<div class="description">SELECT THE CHIP TO FILTER BY UNITS</div>

<div class="options">
  @for (unitOption of unitOptions; track unitOption) {
    <elements-filter-chip
      icon="star"
      [caption]="unitOption.displayName"
      [selected]="isSelected(unitOption)"
      (click)="isSelected(unitOption) ? removeProduct(unitOption) : addProduct(unitOption)"
      >
    </elements-filter-chip>
  }
</div>

<div class="actions">
  <button styles-button (click)="close.emit()">Filter</button>
  <button styles-low-button (click)="clear()">Clear</button>
</div>
